import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const PostbackActions = {
    getListPostbacks(params, callback) {
        dispatch({
            type: AppConstants.POSTBACK_SEARCH_START_LOADING
        });

        api.searchPostbacks({
            page: 1,
            count: 20,
            sort: 'id',
            order: 'desc',
            fields: 'publisher_postback_config.url,publisher_postback_config.method,publisher_postback_config.conversion_statuses,publisher_postback_config.goal_action_ids',
            ...params
        })
            .then(data => {
                dispatch({
                    type: AppConstants.POSTBACK_SEARCH_LOAD_SUCCESS,
                    items: data.response || {}
                });

                callback && callback();
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.POSTBACK_SEARCH_START_FAIL,
                        items: err
                    });
                });
            });
    },

    deletePostback(params, callback) {
        api.deletePostback(params)
            .then(data => {
                dispatch({
                    type: AppConstants.POSTBACK_SEARCH_LOAD_SUCCESS,
                    items: data.response || {}
                });

                callback && callback();
            })
            .catch(err => {
                handleError(err);
            });
    },

    getPostbackParameters(params, callback) {
        dispatch({
            type: AppConstants.POSTBACK_PARAMETERS_START_LOADING
        });

        api.getPostbackParameters(params)
            .then(data => {
                dispatch({
                    type: AppConstants.POSTBACK_PARAMETERS_LOAD_SUCCESS,
                    items: data.response || {}
                });

                callback && callback();
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.POSTBACK_PARAMETERS_FAIL,
                        error: err
                    });
                });
            });
    },

    savePostback(params, callback) {
        dispatch({
            type: AppConstants.POSTBACK_SAVE_START_LOADING
        });

        api.savePostback(params)
            .then(data => {
                dispatch({
                    type: AppConstants.POSTBACK_SAVE_SUCCESS,
                    id: data.response.id
                });

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.POSTBACK_SAVE_FAIL,
                        error: err.error
                    });
                });
            });
    },

    editPostback(params, callback) {
        dispatch({
            type: AppConstants.POSTBACK_SAVE_START_LOADING
        });

        api.editPostback(params)
            .then(data => {
                dispatch({
                    type: AppConstants.POSTBACK_EDIT_SUCCESS
                });

                callback && callback();
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: AppConstants.POSTBACK_SAVE_FAIL,
                        error: err.error
                    });
                });
            });
    },

    clearErrors() {
        dispatch({
            type: AppConstants.POSTBACK_CLEAR_ERROR
        });
    },

    resetState() {
        dispatch({
            type: AppConstants.POSTBACK_RESET_STATE
        });
    }
};

export default PostbackActions;
